import { render, staticRenderFns } from "./answerScriptCollectionForm.vue?vue&type=template&id=390f57a0&scoped=true&"
import script from "./answerScriptCollectionForm.vue?vue&type=script&lang=js&"
export * from "./answerScriptCollectionForm.vue?vue&type=script&lang=js&"
import style0 from "./answerScriptCollectionForm.vue?vue&type=style&index=0&id=390f57a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390f57a0",
  null
  
)

export default component.exports